import CancelIcon from "@mui/icons-material/Cancel";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import LogoutIcon from "@mui/icons-material/Logout";
import SaveIcon from "@mui/icons-material/Save";
import { Button } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export function BackToHomeButton() {
  const navigate = useNavigate();

  return (
    <Button
      variant="outlined"
      color="inherit"
      startIcon={<HomeRoundedIcon />}
      onClick={() => navigate("/")}
      sx={{
        minWidth: { xs: "100%", sm: "auto" },
      }}
    >
      ダッシュボード
    </Button>
  );
}

export function SignOutButton() {
  const navigate = useNavigate();
  const { signOut } = useAuth();

  const handleClick = () => {
    signOut();
    navigate("/login");
  };

  return (
    <Button
      color="inherit"
      variant="text"
      startIcon={<LogoutIcon />}
      onClick={handleClick}
      sx={{ justifyContent: "flex-start" }}
    >
      ログアウト
    </Button>
  );
}

// ----
// 共通: 代表的なアクション用アイコンボタン
// SelectCheckList.js の見た目に合わせる（基本はデフォルトサイズ/アイコンサイズ）
// ----

export function EditIconButton(props) {
  return (
    <IconButton aria-label="edit" {...props}>
      <EditIcon />
    </IconButton>
  );
}

export function DeleteIconButton(props) {
  return (
    <IconButton aria-label="delete" {...props}>
      <DeleteIcon />
    </IconButton>
  );
}

export function SaveIconButton(props) {
  return (
    <IconButton aria-label="save" color="primary" {...props}>
      <SaveIcon />
    </IconButton>
  );
}

export function CancelIconButton(props) {
  return (
    <IconButton aria-label="cancel" color="error" {...props}>
      <CancelIcon />
    </IconButton>
  );
}
